import { useState, useEffect } from 'react';

/**
 * Devuelve true solo después de que el componente se ha montado en el cliente.
 * Útil para evitar hydration mismatches: el primer render (durante hidratación)
 * devuelve false, igual que el HTML prerenderizado, sin divergencias.
 */
export function useMounted() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);
  return mounted;
}
